import Color from 'color';

const base = {
  white: Color('#fff'),
  black: Color('#000'),
};

const named = {
  slate_gray: Color('#748498'),
  fiord: Color('#47566e'),
  big_stone: Color('#182B4A'),
  biscay: Color('#1a3f70'),
  black_squeeze: Color('#EAEFF7'),
  azure_radiance: Color('#1875F0'),
  heather: Color('#C2CCD8'),
  catskill_white: Color('#F8FAFC'),
  blue_zodiac: Color('#13294E'),
  athens_gray: Color('#FBFBFC'),
  link_water: Color('#F5F8FD'),
  apple: Color('#53B336'),
  black_haze: Color('#F1F2F2'),
  silver_chalice: Color('#ADADAD'),
  mariner: Color('#2577D7'),
  regent_gray: Color('#8690A0'),
  clementine: Color('#E66200'),
  lemon_dream: Color('#EDA400'),
  mountain_meadow: Color('#1CAF5E'),
  orange_red: Color('#FF4500'),
  guardsman_red: Color('#ba0101'),
  dimmed_gray: Color('#DADDE6'),
  light_gray: Color('#F4F8FB'),
  monza: Color('#bf003b'),
  limeade: Color('#3bbf00'),
  shiraz: Color('#B80635'),
  aluminum_foil: Color('#d2d9db'),

  dummy_gray: Color('#555'),
  vivid_blue: Color('#1566DA'),
  dark_navy: Color('#171F46'),
  white_smoke: Color('#F4F4F4'),
  lynch: Color('#77869F'),
  sunglow: Color('#FFD03E'),
  crimson_glory: Color('#BF013B'),
  burgundy: Color('#860029'),

  lavender: Color('#FDF3E7'),
};

export const brand = {
  primary: named.fiord,
  success: named.apple,
  error: named.guardsman_red,
};

export const colors = { ...base, ...named, ...brand };

export type ColorName = keyof typeof colors;
